import React from "react"
import { Toggle, Table, TableBody, TableRow, TableRowColumn, FloatingActionButton, CircularProgress, SelectField, MenuItem, IconButton, FontIcon, Chip, LinearProgress } from "material-ui"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../../../components/layout/TableFooter"
import ToolTip from "react-portal-tooltip"
import ContentAdd from "material-ui/svg-icons/content/add"
import { EScheduledJobType, IScheduledJob } from "../../../../models/data/account/settings/IScheduledJob"
import { IScriptLog } from "../../../../models/data/account/settings/IScriptLog"
import AccountManagerSystemTabAccountSelectionDialog from "../../../../components/account_manager/tabs/system_tab_details/AccountManagerSystemTabAccountSelectionDialog"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import AppStateStore from "../../../../stores/AppStateStore"
import AddScheduleJobDialog from "./AddScheduleJobDialog"
import AccountStore from "../../../../stores/AccountStore"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import moment from "moment"
import { green500, red500, blue500 } from "material-ui/styles/colors"
import { IFAMAccountDTO } from "../../../../models/data/account_manager/FAMAccountDTO"
import { IAccountManagerScheduledJobsSearchParams, IAccountManagerScheduledJobsSearch } from "../../../../models"
import he from "he"
import AuthenticationStore from "../../../../stores/AuthenticationStore"

interface IProps {
    isAccountManager?: boolean
    accountManagerId?: string
}
interface IState {
    loading: boolean,
    expand: boolean
    scheduledJobs: IScheduledJob[]
    selectedCategory: string
    openAddScheduledJobDialog: boolean
    selectedScheduledJob: IScheduledJob
    openLogTooltip: boolean
    openDiffTooltip: boolean
    compileErrors: boolean
    compileErrorsText: string
    loadingScriptLog: boolean
    scriptLog: IScriptLog
    diffTooltipIndex: number
    logTooltipIndex: number
    showSystemJobs: boolean
    showAllJobs: boolean
    openAccountManagerAccountSelectionDialog: boolean
    title: string
    selectedClientAccount: IFAMAccountDTO
    actionType: string
    total: number
    offset: number
    limit: number
    loadingSpinner: boolean
    jobType: string
    openAccountSelectionDialogForFilter: boolean
    selectedClientAccountForFilter: IFAMAccountDTO
}

export default class ScheduledJobs extends React.Component<IProps, IState> {
    private refreshTimer
    private ScheduledJobs: IScheduledJob[]
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            expand: false,
            diffTooltipIndex: -1,
            logTooltipIndex: -1,
            scheduledJobs: [],
            selectedCategory: "-1",
            openAddScheduledJobDialog: false,
            selectedScheduledJob: null,
            openLogTooltip: false,
            openDiffTooltip: false,
            compileErrors: false,
            compileErrorsText: "",
            loadingScriptLog: false,
            scriptLog: null,
            showSystemJobs: false,
            showAllJobs: false,
            openAccountManagerAccountSelectionDialog: false,
            title: "",
            selectedClientAccount: null,
            actionType: "",
            total: 0,
            offset: 0,
            limit: 20,
            loadingSpinner: false,
            jobType: strings.All_Client_Scheduled_Jobs,
            openAccountSelectionDialogForFilter: false,
            selectedClientAccountForFilter: null,
        }
    }

    componentDidMount() {
        this.getScheduledJobs()
        this.refreshTimer = setInterval(() => {
            !this.state.loading && !this.state.loadingSpinner && this.getScheduledJobs(false)
        }, 5000)
    }

    componentWillUnmount() {
        this.refreshTimer &&
            clearInterval(this.refreshTimer)
    }

    getJobTypeFilterValue(selectedFilter: string) {
        let filterValue = null
        if (selectedFilter === strings.Client_Accessible_Scheduled_Jobs) filterValue = true
        else if (selectedFilter === strings.Non_Client_Accessible_Scheduled_Jobs) filterValue = false
        return filterValue
    }

    getScheduledJobs(showSpinner = true) {
        this.setState({
            loading: true,
            loadingSpinner: showSpinner
        })

        if (!this.props.isAccountManager) {
            api.getScheduledJobs(AccountStore.getCurrentAccount().Id, this.state.showSystemJobs, this.state.showAllJobs, this.getJobTypeFilterValue(this.state.jobType))
                .then(res => {
                    this.ScheduledJobs = res.data
                    if (showSpinner) this.setState({ scheduledJobs: this.ScheduledJobs, loading: false, loadingSpinner: false })
                    else this.setState({ scheduledJobs: this.ScheduledJobs, loading: false })
                })
        }
        else {
            const scheduledJobSearchParams = {
                AccountManagerId: this.props.accountManagerId,
                ShowSystemJobs: this.state.showSystemJobs,
                Page: this.state.offset / this.state.limit,
                Limit: this.state.limit,
                AccountId: this.state.selectedClientAccountForFilter ? this.state.selectedClientAccountForFilter.AccountId : null,
            } as IAccountManagerScheduledJobsSearchParams

            api.getAccountManagerScheduledJobs(scheduledJobSearchParams)
                .then(resp => {
                    const data = resp.data as IAccountManagerScheduledJobsSearch
                    this.ScheduledJobs = data.Documents
                    if (showSpinner) this.setState({ scheduledJobs: data.Documents, total: data.TotalDocumentsCount, loading: false, loadingSpinner: false })
                    else this.setState({ scheduledJobs: data.Documents, total: data.TotalDocumentsCount, loading: false })
                })
        }
    }

    update(scheduledJob: IScheduledJob) {
        api.updateScheduledJob(this.props.isAccountManager ? scheduledJob.AccountId : AccountStore.getCurrentAccount().Id, scheduledJob)
            .then((res) => {
                this.ScheduledJobs = res.data
                this.setState({
                    scheduledJobs: this.ScheduledJobs,
                    loading: false,
                    openAddScheduledJobDialog: false,
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
            })
    }

    add(scheduledJob: IScheduledJob) {
        const ScheduledJob = scheduledJob
        if (this.props.isAccountManager) {
            ScheduledJob.AccountId = this.state.selectedClientAccount.AccountId
        }
        api.addScheduledJob(this.props.isAccountManager ? ScheduledJob.AccountId : AccountStore.getCurrentAccount().Id, ScheduledJob)
            .then((res) => {
                this.ScheduledJobs = res.data
                this.setState({
                    scheduledJobs: this.ScheduledJobs,
                    loading: false,
                    openAddScheduledJobDialog: false,
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
            })
    }

    loadScriptLog(rowIndex, scheduledJob) {
        this.showLogTooltip(rowIndex)

        api.getLatestScriptLog(this.props.isAccountManager ? scheduledJob.AccountId : AccountStore.getCurrentAccount().Id, scheduledJob.Id)
            .then((res) => {
                this.setState({
                    scriptLog: res.data,
                    loadingScriptLog: false,
                })
            })
    }

    runScript(scheduledJob) {
        api.runScript(this.props.isAccountManager ? scheduledJob.AccountId : AccountStore.getCurrentAccount().Id, scheduledJob.Id)
    }

    delete(scheduledJob) {
        api.deleteScheduledJob(this.props.isAccountManager ? scheduledJob.AccountId : AccountStore.getCurrentAccount().Id, scheduledJob.Id)
            .then(() => {
                this.getScheduledJobs()
            })
    }

    showDiffTooltip(rowIndex) {
        this.setState({
            diffTooltipIndex: rowIndex
        })
    }

    showLogTooltip(rowIndex) {
        this.setState({
            logTooltipIndex: rowIndex,
        })
    }

    getEstimatedTimeToFinishInSeconds(row){
        const startTime = moment(row.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunStartTime)
        const timeSinceStartInSeconds = moment().diff(startTime, "seconds")
        const durationInSeconds = (row.AverageMinutesToFinish*60);
        const timeLeftToFinishInSeconds = durationInSeconds - timeSinceStartInSeconds

        return timeLeftToFinishInSeconds; 
    }

    getEstimatedFinishTime(row){
        const timeLeftToFinishInSeconds = this.getEstimatedTimeToFinishInSeconds(row)

        if(timeLeftToFinishInSeconds < 0){
            return `Overdue ${Math.round(timeLeftToFinishInSeconds/60)*-1} minute(s)`
        }

        return moment().add(timeLeftToFinishInSeconds, "seconds").format("MM/DD/YYYY hh:mma")
    }

    render() {
        let categories = []

        if(this.state.scheduledJobs && this.state.scheduledJobs.length > 0){            
            this.state.scheduledJobs.forEach(sj => {
                if(sj.Category && sj.Category.length > 0){
                    if(!categories.includes(sj.Category.trim().toUpperCase())){
                        categories.push(sj.Category.trim().toUpperCase())
                    }
                }
            })
        }
       
        const isGlobalAdmin = permissionHelper.isGlobalAdmin() ||
            (
                AuthenticationStore.getLoggedInAccountManagerUser() ?
                    permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.AccountScheduledJob) :
                    false
            )
            
        return (
            <div>
                {(isGlobalAdmin || this.props.isAccountManager) &&
                    <FloatingActionButton
                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Btn-Add"}
                        style={{
                            position: "absolute",
                            marginTop: -93,
                            right: 42,
                            display: "inline-block",
                            zIndex: 100
                        }}
                        mini={true}
                        secondary={true}
                        onTouchTap={() => {
                            if (!this.props.isAccountManager) this.setState({ openAddScheduledJobDialog: true, selectedScheduledJob: null })
                            else this.setState({ openAccountManagerAccountSelectionDialog: true, title: strings.Select_Account_For_Which_You_Want_To_Add_Scheduled_Job, selectedClientAccount: null, actionType: "Add" })
                        }}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <div style={{ display: "flex", marginBottom: 30 }}>
                    {isGlobalAdmin &&
                        <Toggle
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Toggle-ShowSystemJobs"}
                            label={strings.ShowSystemJobs}
                            style={{ width: 240, marginTop: 5 }}
                            toggled={this.state.showSystemJobs}
                            onToggle={(e, value) => this.setState({ showSystemJobs: value })}
                        />
                    }
                    {isGlobalAdmin && !this.props.isAccountManager &&
                        <Toggle
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Toggle-ShowAllAccountSystemJobs"}
                            label={strings.ShowAllAccountSystemJobs}
                            style={{ width: 240, marginTop: 5, marginLeft: 50 }}
                            toggled={this.state.showAllJobs}
                            onToggle={(e, value) => this.setState({ showAllJobs: value })}
                        />
                    }
                    {isGlobalAdmin && !this.props.isAccountManager &&
                        <SelectField
                            floatingLabelText={strings.Job_Type}
                            value={this.state.jobType}
                            onChange={(_e, _key, jobType) => {
                                this.setState({ jobType }, () => this.getScheduledJobs())
                            }}
                            style={{ marginLeft: 50, marginTop: -35, width: 310 }}
                        >
                            <MenuItem key={"all"} value={strings.All_Client_Scheduled_Jobs} primaryText={strings.All_Client_Scheduled_Jobs} />
                            <MenuItem key={"client-accessible"} value={strings.Client_Accessible_Scheduled_Jobs} primaryText={strings.Client_Accessible_Scheduled_Jobs} />
                            <MenuItem key={"non-client-accessible"} value={strings.Non_Client_Accessible_Scheduled_Jobs} primaryText={strings.Non_Client_Accessible_Scheduled_Jobs} />
                        </SelectField>
                    }

                    <SelectField
                        floatingLabelText={"Category"}
                        value={this.state.selectedCategory}
                        onChange={(_e, _key, selectedCategory) => {
                            this.setState({ selectedCategory: selectedCategory })
                        }}
                        style={{ marginLeft: 50, marginTop: -35, width: 310 }}
                    >
                        <MenuItem key={"all"} value={"-1"} primaryText={"All"} />
                        {categories.map(i => <MenuItem value={i} primaryText={i} key={i} />)}                            
                    </SelectField>

                    {this.props.isAccountManager &&
                        <div style={{ display: "flex", paddingLeft: 40 }}>
                            <div style={{ paddingTop: 6 }}>
                                {`${strings.Filter_By_Account}:`}
                            </div>
                            {this.state.selectedClientAccountForFilter &&
                                <div style={{ paddingLeft: 15 }}>
                                    <Chip
                                        style={{ height: 35, width: "min-content" }}
                                        onRequestDelete={() => this.setState({ selectedClientAccountForFilter: null }, () => this.getScheduledJobs())}
                                    >
                                        <div
                                            className="TextOverflow"
                                            title={this.state.selectedClientAccountForFilter.Name}
                                        >
                                            {this.state.selectedClientAccountForFilter.Name}
                                        </div>
                                    </Chip>
                                </div>
                            }
                            {this.state.selectedClientAccountForFilter === null &&
                                <IconButton
                                    style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                                    onTouchTap={() => this.setState({ openAccountSelectionDialogForFilter: true })}
                                >
                                    <FontIcon className="fa fa-plus-circle" />
                                </IconButton>
                            }
                        </div>
                    }
                </div>
                {this.state.loadingSpinner ?
                    <div className="spinner"><CircularProgress /></div> :
                    !this.state.scheduledJobs.length ? strings.No_scheduled_jobs :
                        <Table
                            multiSelectable={false}
                            selectable={false}
                            fixedHeader={true}
                            style={{ backgroundColor: "none", borderBottom: "1px solid rgb(224,224,224)", borderTop: "1px solid rgb(224,224,224)" }}
                        >
                            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                                <TableRow style={{ heigth: 45 }}>
                                    {this.state.showAllJobs &&
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                            {strings.Account}
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 200}}>
                                        {strings.Action}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.Name}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 200 }}>
                                        {strings.Status}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                        {strings.System}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                        {strings.CronExpression}
                                    </TableRowColumn>
                                    {(isGlobalAdmin || this.props.isAccountManager) &&
                                        <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 50 }}>
                                            {strings.DiffWithPrevious}
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.Modified_Date}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.LastRunTime}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.NextRunTime}
                                    </TableRowColumn>
                                    {(isGlobalAdmin || this.props.isAccountManager) &&
                                        <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 100 }}>
                                            {strings.Client_Can_View}
                                        </TableRowColumn>
                                    }
                                </TableRow>
                                {this.state.scheduledJobs.filter((sj) => this.state.selectedCategory == "-1" || (sj.Category && sj.Category.trim().toUpperCase() == this.state.selectedCategory)).map((row, i) =>
                                    <TableRow key={i} style={{ heigth: 45 }}>
                                        {this.state.showAllJobs &&
                                            <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                                {row.AccountName}
                                            </TableRowColumn>
                                        }
                                        <TableRowColumn style={{ cursor: "pointer", textAlign: "center" }} className="prevent-cell-click">
                                            <div onClick={e => e.stopPropagation()} style={{display: "grid", gridTemplateColumns: "40px 40px 40px 40px"}}>
                                                <div style={{gridColumn: 1, gridRow: 1}}>
                                                    {(isGlobalAdmin || this.props.isAccountManager) &&
                                                        <i
                                                            data-intercom-target={i === 0 && "ScheduledJobsTable-Btn-DeleteScheduledJob"}
                                                            className="fa fa-trash-o"
                                                            style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                            onClick={() =>
                                                                AppStateStore.setConfirmDialogContent({
                                                                    content: strings.formatString(strings.Are_you_sure_you_want_to_delete_scheduled_job, row.Name) as string,
                                                                    confirm: () => this.delete(row)
                                                                })
                                                            }
                                                        />
                                                    }
                                                </div>                                                
                                                <div style={{gridColumn: 2, gridRow: 1}}>
                                                    <i
                                                        data-intercom-target={i === 0 && "ScheduledJobsTable-Btn-OpenAddScheduledJobDialog"}
                                                        className="fa fa-pencil"
                                                        style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                        onClick={() => {
                                                            this.setState({ selectedScheduledJob: row, openAddScheduledJobDialog: true })
                                                        }}
                                                    />                                                   
                                                </div>
                                                <div style={{gridColumn: 3, gridRow: 1}}>
                                                    {(isGlobalAdmin || this.props.isAccountManager) &&
                                                        (row.CurrentScript.ScriptLogs.length > 0) &&
                                                        <i className="fa fa-download"
                                                            data-intercom-target={i === 0 && "ScheduledJobsTable-Btn-Download"}
                                                            style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                            onClick={() => {
                                                                var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(row.CurrentScript.ScriptLogs));
                                                                var dlAnchorElem = document.getElementById("downloadAnchorElem");
                                                                dlAnchorElem.setAttribute("href", dataStr);
                                                                dlAnchorElem.setAttribute("download", `${row.Name}-${moment(row.CurrentScript.ScriptLogs["ScriptRunEndTime"]).format("MM/DD/YYYY hh:mma").replace(" ", "-")}.json`);
                                                                dlAnchorElem.click();
                                                            }} />
                                                    }
                                                    <a id="downloadAnchorElem" style={{ "display": "none" }} />
                                                </div>
                                                <div style={{gridColumn: 4, gridRow: 1}}>
                                                    {row.Enabled &&
                                                        <i
                                                            data-intercom-target={i === 0 && "ScheduledJobsTable-Btn-RunSchecduledJob"}
                                                            className="fa fa-play"
                                                            style={{ color: green500, fontSize: 20, fontWeight: "bold", cursor: "pointer" }}
                                                            onClick={() => {
                                                                AppStateStore.setConfirmDialogContent({
                                                                    content: strings.formatString(strings.Are_you_sure_you_want_to_run_scheduled_job, row.Name) as string,
                                                                    confirm: () => this.runScript(row)
                                                                })
                                                            }}
                                                        />
                                                    }
                                                </div>                                                
                                            </div>
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                            {row.Name}{row.Enabled ? "" : " - (disabled)"}
                                        </TableRowColumn>
                                        <TableRowColumn
                                            id={"status-" + i}
                                            style={{ textAlign: "left", paddingLeft: 0, width: 200, cursor: "pointer" }}
                                            onMouseEnter={() => this.showLogTooltip(i)}
                                            onMouseLeave={() => this.showLogTooltip(-1)}
                                        >
                                            {row.CurrentScript.ScriptLogs.length > 0 &&
                                                <div style={{height: (row.InProcess && (row.Progress && row.Progress.TotalProgress > 0 ) ? 150 : null), 
                                                    paddingTop: (row.InProcess && row.Progress && row.Progress.TotalProgress > 0 ? 20 : null), 
                                                    paddingBottom: (row.InProcess && row.Progress && row.Progress.TotalProgress > 0 ? 20 : null)}}>
                                                    {row.InProcess &&
                                                        <i className="fa fa-cog fa-spin" style={{ fontSize: 15 }} />
                                                    }
                                                    {row.InProcess &&
                                                        <span> {strings.Running} {row.CurrentScript.ScriptLogs.slice(-1)[0].MostRecentLog}</span>
                                                    }
                                                    {(!row.InProcess && row.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                        <i className="fa fa-check" style={{ fontSize: 15, color: green500, fontWeight: "bold" }} />
                                                    }
                                                    {(!row.InProcess && row.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                        <span style={{ fontSize: 15, color: green500 }}> {strings.Finished}</span>
                                                    }
                                                    {(!row.InProcess && !row.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                        <i className="fa fa-exclamation-triangle" style={{ fontSize: 15, color: red500, fontWeight: "bold" }} />
                                                    }
                                                    {(!row.InProcess && !row.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                        <span style={{ fontSize: 15, color: red500 }}> {strings.Error}</span>
                                                    }
                                                    {row.InProcess && row.Progress && row.Progress.TotalProgress > 0 &&
                                                        <div style={{borderTop: "solid 1px #cccccc", marginTop: 10, marginBottom: 20, paddingTop: 5, paddingBottom: 5}}>
                                                            <div>
                                                                <span>{Math.round((row.Progress.ProgressCount / row.Progress.TotalProgress) * 100)}% – {row.Progress.ProgressText}</span>
                                                                <LinearProgress mode="determinate" value={row.Progress.ProgressCount} max={row.Progress.TotalProgress} color={"#1181F2"}/>
                                                            </div>
                                                            {row.Progress.TotalSubProgress > 0 &&
                                                                <div style={{marginTop: 10}}>
                                                                    <span>{Math.round((row.Progress.SubProgressCount / row.Progress.TotalSubProgress) * 100)}% – {row.Progress.SubProgressText}</span> 
                                                                    <LinearProgress mode="determinate" value={row.Progress.SubProgressCount} max={row.Progress.TotalSubProgress} color={"#1181F2"}/>
                                                                </div>
                                                            }

                                                            <div style={{marginTop: 15}}>
                                                                <div><b>Est. Finish Time: </b></div>
                                                                <span>{this.getEstimatedFinishTime(row)}</span>
                                                            </div>
                                                            {(Math.round(this.getEstimatedTimeToFinishInSeconds(row)/60)) > 0 && 
                                                                <div>
                                                                    <span>{(Math.round(this.getEstimatedTimeToFinishInSeconds(row)/60))}</span> minute(s) to finish
                                                                </div>
                                                            }      
                                                        </div>
                                                    }                                                                    

                                                    <ToolTip
                                                        active={i === this.state.logTooltipIndex}
                                                        position="top"
                                                        arrow="right"
                                                        parent={"#status-" + i}
                                                        key={"#status-" + i}
                                                        group={"#status-" + i}
                                                    >   

                                                        {row.CurrentScript.ScriptLogs.slice(-1)[0].LogText &&
                                                            <div style={{ padding: 5, width: 500 }}>
                                                                <div>
                                                                    <div><b>Start Time: </b>{moment(row.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunStartTime).format("MM/DD/YYYY hh:mm:ssa")}</div>
                                                                    {!row.InProcess && 
                                                                        <div>
                                                                            <b>End Time: </b>
                                                                            {row.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunEndTime != null
                                                                                ? moment(row.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunEndTime).format("MM/DD/YYYY hh:mm:ssa")
                                                                                : ""}
                                                                        </div>
                                                                    }
                                                                    {!row.InProcess && <div><b>Duration in Minutes: </b>{row.CurrentScript.ScriptLogs.slice(-1)[0].MinutesToFinish}</div>}
                                                                    <div><b>Latest Log: </b>{row.CurrentScript.ScriptLogs.slice(-1)[0].MostRecentLog}</div>
                                                                </div>                                             
                                                                <div style={{ padding: 5, paddingLeft: 15, backgroundColor: "#666666", color: "#cccccc", overflowY: "auto", maxHeight: 600 }}>
                                                                    <pre>{row.CurrentScript.ScriptLogs.slice(-1)[0].LogText}</pre>
                                                                </div>
                                                            </div>
                                                        }
                                                    </ToolTip>
                                                </div>
                                            }
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 20 }}>
                                            {row.System ? (<i className="fa fa-check" style={{ fontSize: 18, color: green500 }} />) : ""}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 20 }}>
                                            {row.CronExpression}
                                        </TableRowColumn>
                                        {(isGlobalAdmin || this.props.isAccountManager) &&
                                            <TableRowColumn
                                                style={{ textAlign: "center", paddingLeft: 0 }}
                                            >
                                                {row.CurrentScript.DiffWithPreviousHtml &&
                                                    <div>
                                                        <i className="fa fa-exchange" style={{ fontSize: 20, cursor: "pointer", color: blue500 }}
                                                            id={"exchange-" + i}
                                                            onMouseEnter={() => this.showDiffTooltip(i)}
                                                            onMouseLeave={() => this.showDiffTooltip(-1)}
                                                        />
                                                        <ToolTip
                                                            active={i === this.state.diffTooltipIndex}
                                                            position="top"
                                                            arrow="left"
                                                            parent={"#exchange-" + i}
                                                            key={"#exchange-" + i}
                                                            group={"#exchange-" + i}
                                                        >
                                                            <div style={{ padding: 5, width: 1000 }}>
                                                                <div style={{ padding: 5, paddingLeft: 15, overflowY: "auto", maxHeight: 550, width: 990 }} dangerouslySetInnerHTML={{ __html: he.decode(row.CurrentScript.DiffWithPreviousHtml) }} />
                                                            </div>
                                                        </ToolTip>
                                                    </div>
                                                }
                                            </TableRowColumn>
                                        }
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                            {row.CurrentScript.ObjectAudit ? moment(row.CurrentScript.ObjectAudit.LastModified).format("MM/DD/YYYY hh:mma") : ""}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                            {row.LastRunTime ? moment(row.LastRunTime).format("MM/DD/YYYY hh:mma") : ""}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                            {row.NextRunTime ? moment(row.NextRunTime).format("MM/DD/YYYY hh:mma") : ""}
                                        </TableRowColumn>
                                        {(isGlobalAdmin || this.props.isAccountManager) &&
                                            <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 100 }}>
                                                {row.CanClientView && <i className="fa fa-check" style={{ fontSize: 20, color: green500, fontWeight: "bold" }} />}
                                            </TableRowColumn>
                                        }
                                    </TableRow>
                                )}
                            </TableBody>
                            {this.props.isAccountManager &&
                                <TF>
                                    <TableFooter
                                        total={this.state.total}
                                        offset={this.state.offset}
                                        limit={this.state.limit}
                                        limitOptions={[20, 50, 100]}
                                        onPageClick={offset => this.setState({ offset }, () => this.getScheduledJobs())}
                                        onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.getScheduledJobs())}
                                    />
                                </TF>
                            }
                        </Table>
                }
                {this.state.openAddScheduledJobDialog &&
                    <AddScheduleJobDialog
                        type={EScheduledJobType.General}
                        editScheduledJob={this.state.selectedScheduledJob}
                        handleClose={() => this.setState({ openAddScheduledJobDialog: false })}
                        handleAdd={scheduledJob => this.add(scheduledJob)}
                        handleUpdate={scheduledJob => this.update(scheduledJob)}
                    />
                }
                {this.state.openAccountManagerAccountSelectionDialog &&
                    <AccountManagerSystemTabAccountSelectionDialog
                        open={this.state.openAccountManagerAccountSelectionDialog}
                        title={this.state.title}
                        onClose={() => {
                            this.setState({ openAccountManagerAccountSelectionDialog: false })
                        }}
                        onSelect={(selectedClientAccount) => {
                            this.setState({ selectedClientAccount, openAccountManagerAccountSelectionDialog: false }, () => {
                                if (this.state.actionType === "Add") this.setState({ openAddScheduledJobDialog: true, selectedScheduledJob: null })
                            })
                        }}
                        accountManagerId={this.props.accountManagerId}
                    />
                }
                {this.state.openAccountSelectionDialogForFilter &&
                    <AccountManagerSystemTabAccountSelectionDialog
                        open={this.state.openAccountSelectionDialogForFilter}
                        title={strings.Filter_By_Account}
                        onClose={() => this.setState({ openAccountSelectionDialogForFilter: false })}
                        onSelect={(selectedClientAccountForFilter) => this.setState({ selectedClientAccountForFilter, openAccountSelectionDialogForFilter: false }, () => this.getScheduledJobs())}
                        accountManagerId={this.props.accountManagerId}
                    />
                }
            </div>
        )
    }
}